import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Package } from '@app/_models/package';
import { PrintCertificateState } from '@app/_models/printCertificateState';
import { environment } from '@environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PackageService {
  // printPackage: Package = { "certificateNumber": "AANIA120822001059", "policyNumber": "35070742200100000077","invoiceUrl":"", "vehicleType": "Two Wheeler", "vehicleMake": "Hero Motocorp Limited", "model": "Acheiver", "type": "New", "variant": "", "vehicleYear": "2023", "registrationNumber": "New", "chasisNumber": "test1234567890123", "engineNumber": "kdlsjfksw", "firstName": "Dealer", "lastName": "Test", "email": "abc.def@gmail.com", "clientType": "Individual", "employeeContactNumber": "NA", "contactNumber": "7738183366", "gender": "Male", "dob": "2005-04-11", "ageOrDob": "dob", "age": 18, "gstin": "", "address": "GOHANA", "state": "Haryana", "city": "Sonipat", "nomineeName": "tset", "nomineeRelationship": "Wife", "nomineeGender": "Male", "nomineeAge": "23", "planId": "Plan348", "planAmount": 295, "planGSTAmount": 53, "planTotalAmount": 348, "SgstAmount": 0, "CgstAmount": 0, "IgstAmount": 0, "startDate": "2023-04-11T05:40:30.000Z", "endDate": "2023-04-09T18:30:00.000Z", "issueDate": "2023-04-11T05:40:30.000Z", "userId": "62ef9cf8e32a42db81c7894e", "createdDate": new Date("2023-04-11T05:43:01.293Z"), "updatedDate": new Date("2023-04-11T05:43:01.293Z"), "personalAccidentCover": 1500000, "userName": "admin2", "dealerName": "Lokesh kharbash", "dealerId": "DLR-10000003", "dealerEmail": "lokesh.kharbash@gmail.com", "endorsementReason": "", "cancellationReason": "", "endorsementCount": 0, "policyType": "PA1", "issueDateString": "2023-04-11", "dealerBalance": -112629, "certificateStatus": "Submitted", "gstApplicable": "N", "gstShow": "N", "printCpaPolicy": "Yes", "financeCompanyName": "HDB FINANCIAL SERVICES LTD", "financeCoverAmount": null, "planCPACoverAmount": 1500000, "nomineeCoverAmount": 1500000, "printRsaNumber": "No", "rsaNumberOfServices": 0, "rsaProvidedCount": 0, "prePolClaim": "", "transferCase": "", "idv": 35000, "prevPolicyExpire": "", "rto": "AP 21-Kurnool", "nilDep": "Yes", "hypothecated": "Yes", "aadhaarNumber": 219812341235, "aadhaarUrl": "PKG1000000556-Aadhaar.PNG", "panNumber": "ABCDE1234L", "panUrl": "PKG1000000556-Pan.jpg", "financeCompanyAddress": "test", "prevOdInsurer": "", "prevOdPolicyNo": "", "prevOdPolicyExpiry": null, "prevTpInsurer": "", "prevTpPolicyNo": "", "prevTpPolicyExpiry": null, "insuranceCompany": "Bajaj Allianz General Insurance Co. Ltd.", "packageId": "BajajPackage001", "packageNumber": "PKG1000000556", "package": { "packageId": "BajajPackage001", "packageName": "Bundled - 1 Year OD + 5 Year TP", "applicableOn": "New",  "prevInsuranceDetailShow": [] }, "packageStatus": "Certificate Generated", "policyStatus": "Created", "pincode": 122001, "insPolicyPdfUrl": "PKG1000000556-Inspolicy.pdf", "insurancePolicyNumber": "testPolicy", "insurancePolicyAmount": 1000, "insurancePolicyGStAmount": 180, "insurancePolicyTotalAmount": 1180, "packagePolicyAmount": 1295, "packagePolicyGStAmount": 233, "packagePolicyTotalAmount": 1528, "createdFromPackage": true, "id": "64396c0fb1726b1b15d71602" };
  private packageSubject: BehaviorSubject<Package>;
  currentPackage: Observable<Package>;
  printPackage:Package;
  private printCertificateState: PrintCertificateState;

  constructor(private http: HttpClient) { 
    this.packageSubject = new BehaviorSubject<Package>(new Package());
    this.currentPackage = this.packageSubject.asObservable();
  }
  public get currentPackageValue(): Package {
    return this.packageSubject.value;
}
  getPrintCertificateState() {
    return this.printCertificateState;
  }
  setPrintCertificateState(state: PrintCertificateState) {
    this.printCertificateState = state;
  }
  setCurrentPackage(packageDtl: Package) {
    this.packageSubject.next(packageDtl);
  }
  updatePackageInPrintCertificateState(packageDtl: Package) {
    this.printCertificateState.packageList =  this.printCertificateState.packageList.map(element => {
      if (element.packageNumber == packageDtl.packageNumber) {
        return new Package(packageDtl);
      }
      else
      {
        return element;
      }
    });
  }
  issuePackage(packageDtl: Package) {
    return this.http.post<Package>(`${environment.apiUrl}/package/issuePackage`, packageDtl);
  }
  confirmPackage(packageDtl: Package) {
    return this.http.post<Package>(`${environment.apiUrl}/package/confirmPackage`, packageDtl);
  }
  generateCertificate() {
    return this.http.post<Package>(`${environment.apiUrl}/package/generateCertificate`, this.printPackage);
  }
  sharePackage() {
    return this.http.post<Package>(`${environment.apiUrl}/package/sharePackage`, this.printPackage);
  }
  cancelPackage(packageInput: Package) {
    return this.http.post<Package>(`${environment.apiUrl}/package/cancelPackage`, packageInput);

  }
  endorsePackage(packageInput: Package) {
    return this.http.post<Package>(`${environment.apiUrl}/package/endorsePackage`, packageInput);

  }
  requestCancelPackage(packageInput: Package) {
    return this.http.post<Package>(`${environment.apiUrl}/package/requestCancelPackage`, packageInput);
  }
  updatePackageStatus() {
    return this.http.post<Package>(`${environment.apiUrl}/package/updatePackageStatus`, this.printPackage);

  }
  requestEndorsePackage(packageInput: Package) {
    return this.http.post<Package>(`${environment.apiUrl}/package/requestEndorsePackage`, packageInput);
  }

}
